import React, { useMemo } from 'react'
import { buildEmailHtml } from '../lib/emailBuilder'
import { buildDigestText, formatIssueDate } from '../lib/digest'

export default function PreviewModal({ issue, stories, intro, onClose }) {
  const html = useMemo(
    () => buildEmailHtml(buildDigestText({ sendDate: issue.send_date, intro, stories })),
    [issue.send_date, intro, stories]
  )
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="preview-modal" onClick={e => e.stopPropagation()}>
        <div className="preview-modal-header">
          <span className="preview-modal-title">Email Preview — {formatIssueDate(issue.send_date)}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="preview-modal-body">
          <iframe srcDoc={html} title="Email preview" className="preview-iframe" sandbox="allow-same-origin allow-scripts" />
        </div>
      </div>
    </div>
  )
}
